import React from 'react';
import { CTAButton } from './CTAButton';
type Tone = 'canvas' | 'white' | 'ink' | 'soft';
type SectionProps = {
  id?: string;
  tone?: Tone;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  cta?: string;
  ctaNote?: string;
  children: React.ReactNode;
};
const toneClasses: Record<Tone, string> = {
  canvas: 'bg-canvas text-ink',
  white: 'bg-white text-ink',
  ink: 'bg-brand-deep text-white',
  soft: 'bg-brand-soft text-ink'
};
export function Section({
  id,
  tone = 'canvas',
  title,
  subtitle,
  cta,
  ctaNote,
  children
}: SectionProps) {
  const onDark = tone === 'ink';
  return <section id={id} className={`${toneClasses[tone]} px-4 py-16 sm:px-6 md:py-24`} data-id="element-247" data-mp="2qn6829x2p53">
      <div className="mx-auto max-w-5xl" data-id="element-248" data-mp="7oopoob98qh3">
        {title && <div className="mx-auto mb-10 max-w-3xl text-center md:mb-14" data-id="element-249" data-mp="7mvgb199bs5e">
            <h2 className="font-serif text-[32px] font-bold leading-[1.12] sm:text-4xl md:text-5xl" data-id="element-250" data-mp="vdr6jty2efaj">{title}</h2>
            {subtitle && <p className={`mt-4 text-lg leading-relaxed ${onDark ? 'text-white/80' : 'text-muted'}`} data-id="element-251" data-mp="2zklemig9cohv">{subtitle}</p>}
          </div>}
        {children}
        {cta && <div className="mt-12" data-id="element-252" data-mp="2ujnzkeqjoakl">
            <CTAButton label={cta} note={ctaNote} onDark={onDark} data-id="element-253" data-mp="38d5hjv3l1f8i" />
          </div>}
      </div>
    </section>;
}